export default "__VITE_ASSET__Cntsm6cL__"